<template lang="pug" src="./bonuses.pug"></template>

<script>
export default {};
</script>
